import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../common/spinner/loadSpinner";
import Menucustom from "../../common/menu/menucustom";
import RicercaSanzioneService from "./ricercaSanzioneService";
import { BsFillCircleFill } from "react-icons/bs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
import { Modal, Button, Row, Col, Form } from "react-bootstrap";
import moment from "moment";

toast.configure();

class RecezionePagamento extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      sanzioni: [],
      sanzione: "",
      cercaSanzione: "",
      sanzioneTrovata: false,
      dati: "",
    };
  }

  componentDidMount() {
    // console.log(this.props.location.search);
    // console.log(this.props.location.search.id)
    // this.ricercaSanzioneService = new RicercaSanzioneService();
    // this.ricercaSanzioneService.getSanzioni(id, this.sanzione.bind(this));
    // this.ricercaSanzioneService.pagaSanzione((result) => {
    //   console.log(result);
    // });

    const params = new URLSearchParams(this.props.location.search);
    var dati = params.get("dati");
    if(dati === "Successo"){
      this.props.history.push("/ricercaSanzione?id=1");
    }
  }

  render() {
    const dataRilascio = new Date(this.state.sanzione.dataDiEmissione);
    // var data = dataRilascio.getDay(). + "/" + dataRilascio.getMonth() + "/" + dataRilascio.getFullYear() + " " + dataRilascio.getHours() + ":" + dataRilascio.getMinutes()
    var data =
      dataRilascio.toLocaleDateString("it-IT") +
      " " +
      dataRilascio.toLocaleTimeString("it-IT");
    const params = new URLSearchParams(this.props.location.search);
    var dati = params.get("dati");

    var datas = Date(data);
    return (
      <>
        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <br></br>

        {dati === "Successo" ? (
          <h3>Successo</h3>
        ) : (
          <h4>Qualcosa è andato storto</h4>
        )}

        <table>
          <thead>
            <tr>
              <th>&nbsp;</th>
              <th>&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <th>&nbsp;</th>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </>
    );
  }
}

export default RecezionePagamento;
